import { Modal, Row } from 'antd';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import TableComponent from 'components/atoms/TableComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import SpravovaneLeiCard from 'components/molecules/Lei/SpravovaneLeiCard';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import useProfily from 'hooks/useProfily';

import leiAktualizace from 'services/lei/leiAktualizace';
import leiContactApi from 'services/lei/leiContact';
import leiDetailApi from 'services/lei/leiDetail';
import { leiPrevodGet } from 'services/lei/leiTransfer';
import leiZadostiApi, { ILeiPrehledZadosti, ILeiZadost } from 'services/lei/leiZadosti';
import leiZruseniZadostiApi from 'services/lei/leiZruseniZadosti';
import leiDataApi from 'services/lei/novyLeiData';

import { EPeriodType } from 'enums/lei/leiDataEnums';
import { ELeiStavZadosti } from 'enums/lei/leiStavZadosti';
import { ETypZadosti } from 'enums/lei/leiTypZadosti';
import { EMaterskaSpol } from 'enums/lei/materskaSpol';
import { ENotificationType } from 'enums/notificationType';
import routePathEnum from 'enums/routePathEnum';

const DetailLei: React.FC = () => {
    const { navigateWorkaround } = useNavigateWorkaround();
    const { lei, aktivniFirma, NotificationComponent } = useContext(Context);
    const { setLevel } = useProfily();
    const [podaneZadosti, setPodanezadosti] = useState<ILeiPrehledZadosti>();
    const [loading, setLoading] = useState<boolean>(false);
    const [showInfoUpdate, setShowInfoUpdate] = useState<boolean>(false);
    const [offset, setOffset] = useState<number>(0);
    const [modalMessage, setModalMessage] = useState<string>('');
    const [refetch, setRefetch] = useState<boolean>(false);

    const goToNoveLei = (row: ILeiZadost) => {
        setLoading(true);
        leiDataApi('get', row.idzadosti, lei?.idVarsymZadosti?.varsym || '0').then(data => {
            setLevel('lei', {
                ...lei,
                data: {
                    ...data
                },
                idVarsymZadosti: {
                    varsym: lei?.idVarsymZadosti?.varsym || '0',
                    id: row.idzadosti
                },
                datumPodani: row.datumpodani,
                stavZadosti: row.stav
            });
            data.platba && data.platba.typplatby === 'KARTOU' && setLevel('platbaLei', data.platba);
            navigateWorkaround(`/firma/${aktivniFirma?.iducet}${routePathEnum.LEI_NOVY}`);
        });
    };

    const goToAktualizace = (row: ILeiZadost, overWriteData: boolean) => {
        setLoading(true);
        leiAktualizace('get', lei?.idVarsymZadosti?.varsym || '0', row.idzadosti)
            .then(data => {
                setLevel('lei', {
                    ...lei,
                    detailData: overWriteData
                        ? {
                              ...lei?.detailData,
                              //  typzadosti: ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY,
                              entitycheck: lei?.detailData?.entitycheck || 'N/A',
                              osoba: {
                                  ...lei?.detailData?.osoba,
                                  soubory: []
                              },
                              matky: lei?.detailData?.matky?.map(e => {
                                  const matka = {
                                      ...e
                                  };
                                  e.stav === EMaterskaSpol.ANO && delete matka.duvod;
                                  return {
                                      ...matka,
                                      ...(e.informacekmatce && {
                                          informacekmatce: {
                                              datumodkdyplatnost:
                                                  e.informacekmatce?.datumodkdyplatnost ||
                                                  e.informacekmatce.relationshipperiod?.filter(
                                                      o => o.periodtype === EPeriodType.RELATIONSHIP_PERIOD
                                                  )[0].startdate,
                                              konsolidace: e.informacekmatce?.konsolidace,
                                              podilspolecnosti: e.informacekmatce?.podilspolecnosti,
                                              soubory: [],
                                              relationshipperiod: e.informacekmatce?.relationshipperiod?.filter(
                                                  o => o.periodtype === EPeriodType.RELATIONSHIP_PERIOD
                                              )
                                          }
                                      })
                                  };
                              })
                          }
                        : {
                              ...data,
                              stavleiplatba: lei?.detailData?.stavleiplatba
                          },
                    paymentDueDate: data.paymentduedate || lei?.paymentDueDate,
                    idVarsymZadosti: {
                        varsym: lei?.idVarsymZadosti?.varsym || '0',
                        id: row.idzadosti
                    },
                    stavZadosti: row.stav,
                    datumPodani: row.datumpodani
                });
                data.platba && data.platba.typplatby === 'KARTOU' && setLevel('platbaLei', data.platba);
                overWriteData
                    ? setShowInfoUpdate(true)
                    : navigateWorkaround(`/firma/${aktivniFirma?.iducet}${routePathEnum.LEI_UPRAVA}`);
            })
            .finally(() => setLoading(false));
    };
    const goToPrevod = (row: ILeiZadost) => {
        setLoading(true);
        leiPrevodGet(lei?.idVarsymZadosti?.varsym || '0', row.idzadosti)
            .then(data => {
                setLevel('lei', {
                    ...lei,
                    prevodData: {
                        ...data
                        // stavleiplatba: lei?.detailData?.stavleiplatba
                    },
                    // paymentDueDate: data.paymentduedate || lei?.paymentDueDate,
                    idVarsymZadosti: {
                        varsym: lei?.idVarsymZadosti?.varsym || '0',
                        id: row.idzadosti
                    },
                    stavZadosti: row.stav,
                    datumPodani: row.datumpodani
                });
                data.platba && data.platba.typplatby === 'KARTOU' && setLevel('platbaLei', data.platba);
                navigateWorkaround(`/firma/${aktivniFirma?.iducet}${routePathEnum.LEI_PREVOD}`);
            })
            .finally(() => setLoading(false));
    };

    const goToKontakt = (row: ILeiZadost) => {
        setLoading(true);
        leiContactApi('get', lei?.idVarsymZadosti?.varsym || '0', row.idzadosti).then(data => {
            setLevel('lei', {
                ...lei,
                contactData: data.osoba,
                idVarsymZadosti: {
                    varsym: lei?.idVarsymZadosti?.varsym || '0',
                    id: row.idzadosti
                },
                datumPodani: row.datumpodani,
                stavZadosti: row.stav
            });
            navigateWorkaround(`/firma/${aktivniFirma?.iducet}${routePathEnum.LEI_KONTAKT}`);
        });
    };

    useEffect(() => {
        if (lei?.idVarsymZadosti?.varsym) {
            setLoading(true);
            leiZadostiApi(lei.idVarsymZadosti.varsym)
                .then(resp => {
                    setPodanezadosti(resp);
                    lei?.idVarsymZadosti?.varsym &&
                        /*  resp.lei.filter(
                        e =>
                            (e.stav === ELeiStavZadosti.KONTROLA || e.stav === ELeiStavZadosti.HOTOVO) &&
                            e.typzadosti === 'REGISTRACE'
                    ).length > 0 */
                        leiDetailApi(lei.idVarsymZadosti.varsym)
                            .then(responzo =>
                                setLevel('lei', {
                                    ...lei,
                                    detailData: responzo,
                                    paymentDueDate: responzo.paymentduedate,
                                    selectedLei: resp.leidetail || lei.selectedLei
                                })
                            )
                            .catch(() => {
                                setLoading(false);
                                setLevel('lei', {
                                    ...lei,
                                    selectedLei: resp.leidetail || lei.selectedLei
                                });
                            })
                            .finally(() => {
                                setLoading(false);
                            });
                })
                .catch(err => {
                    setLoading(false);
                    if (err.response.status === 409) {
                        setLevel('aktivniFirma', null);
                        setLevel('lei', null);
                        navigateWorkaround(routePathEnum.NOVY_UCET.replace(':typ?', 'SPRAVCELEI'));
                    } else {
                        navigateWorkaround(`/firma/${aktivniFirma?.iducet}${routePathEnum.LEI}`);
                    }
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offset, refetch]);

    const columns = [
        {
            title: <TranslateText>EMP_PODANE_ZADOSTI_DATUM_PODANI</TranslateText>,
            key: 'datumpodani',
            dataIndex: 'datumpodani',
            render: (datumpodani: string | null | undefined) => {
                return dayjs(datumpodani).format(' DD.MM.YYYY');
            }
        },
        {
            title: <TranslateText>TYP_ZADOSTI</TranslateText>,
            key: 'typzadosti',
            dataIndex: 'typzadosti',
            render: (typzadosti: string) =>
                typzadosti ? (
                    <div>
                        <TranslateText>{`LEI_TYPZADOSTI_${typzadosti.toUpperCase()}`}</TranslateText>
                    </div>
                ) : (
                    ''
                )
        },
        {
            title: <TranslateText>EMP_PODANE_ZADOSTI_STAV</TranslateText>,
            key: 'stav',
            dataIndex: 'stav',
            render: (stav: string) =>
                stav ? <TranslateText>{`LEI_STAVUCTU_${stav.toUpperCase()}`}</TranslateText> : ''
        },
        {
            dataIndex: 'edit',
            key: 'edit',
            width: 200,
            render: (_: ILeiZadost, row: ILeiZadost, index: number) => (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-evenly',
                        flexGrow: 1
                    }}
                >
                    {(row.stav === ELeiStavZadosti.ROZP ||
                        row.stav === ELeiStavZadosti.PLACENI ||
                        (row.stav === ELeiStavZadosti.HOTOVO && row.typzadosti !== ETypZadosti.KONTAKTNIUDAJE)) && (
                        <AnchorComponent
                            id={`detailLeiEditBtn${index}`}
                            onClick={() => {
                                row.typzadosti === ETypZadosti.REGISTRACE
                                    ? goToNoveLei(row)
                                    : row.typzadosti === ETypZadosti.AKTUALIZACE
                                      ? goToAktualizace(
                                            row,
                                            !!(
                                                row.datumpodani &&
                                                lei?.detailData?.lastupdate &&
                                                dayjs(row.datumpodani) < dayjs(lei?.detailData?.lastupdate)
                                            )
                                        )
                                      : row.typzadosti === ETypZadosti.PREVOD
                                        ? goToPrevod(row)
                                        : goToKontakt(row);
                            }}
                        >
                            <TranslateText>
                                {row.stav === ELeiStavZadosti.HOTOVO && row.typzadosti !== ETypZadosti.KONTAKTNIUDAJE
                                    ? 'ZOBRAZIT'
                                    : 'POKRACOVAT'}
                            </TranslateText>
                        </AnchorComponent>
                    )}

                    {(row.stav === ELeiStavZadosti.ROZP || row.stav === ELeiStavZadosti.PLACENI) && (
                        <AnchorComponent
                            id={`detailLeiZrusitBtn${index}`}
                            onClick={() => {
                                setLoading(true);
                                row.typzadosti &&
                                    leiZruseniZadostiApi(lei?.idVarsymZadosti?.varsym || '', row.idzadosti)
                                        .then(() => {
                                            NotificationComponent({
                                                type: ENotificationType.SUCCESS,
                                                description: 'EMP_PODANE_ZADOSTI_ZADOST_BYLA_ZRUSENA'
                                            });
                                            /* podaneZadosti?.lei.length === 1
                                                ? navigateWorkaround(`/firma/${aktivniFirma?.iducet}${routePathEnum.LEI}`)
                                                : */ setRefetch(pv => !pv);
                                        })
                                        .finally(() => setLoading(false));
                            }}
                        >
                            <TranslateText>ZRUSIT</TranslateText>
                        </AnchorComponent>
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <LoadingWrapper loading={loading}>
                {!loading && (
                    <>
                        <Title
                            level={3}
                            text={lei?.selectedLei?.lei || `LEI_STAVUCTU_${lei?.selectedLei?.stav || 'ROZP'}`}
                        />
                        {lei?.selectedLei && <SpravovaneLeiCard ucet={lei?.selectedLei} />}
                    </>
                )}
            </LoadingWrapper>
            <Modal
                title={<TranslateText>{'VYJADRENI_CDCP'}</TranslateText>}
                open={!!modalMessage}
                onCancel={() => setModalMessage('')}
                afterClose={() => {
                    setModalMessage('');
                }}
                footer={
                    <Row>
                        <ButtonComponent
                            buttontext="ZAVRIT"
                            id="detailLeiZavritModalBtn"
                            onClick={() => {
                                setModalMessage('');
                            }}
                        />
                    </Row>
                }
            >
                <Row>
                    <Paragraph text={modalMessage} />
                </Row>
            </Modal>
            <Modal
                title={<TranslateText>{'LEI_DATA_AKTUALIZOVANE'}</TranslateText>}
                open={!!showInfoUpdate}
                onCancel={() => setShowInfoUpdate(false)}
                afterClose={() => {
                    setShowInfoUpdate(false);
                }}
                footer={
                    <Row>
                        <ButtonComponent
                            buttontext="OK"
                            id="detailLeiZavritModalBtn"
                            onClick={() => {
                                navigateWorkaround(`/firma/${aktivniFirma?.iducet}${routePathEnum.LEI_UPRAVA}`);
                            }}
                        />
                    </Row>
                }
            >
                <Row>
                    <Paragraph text={modalMessage} />
                </Row>
            </Modal>
            <TableComponent
                columns={columns}
                rowKey={record => record.idzadosti}
                dataSource={podaneZadosti?.lei.sort((a, b) => +new Date(b.datumpodani) - +new Date(a.datumpodani))}
                loading={!podaneZadosti || loading}
                pagination={{
                    total: podaneZadosti?.count,
                    onChange: page => setOffset((page - 1) * 10),
                    current: offset / 10 + 1,
                    showSizeChanger: false
                }}
                locale={{
                    emptyText: <TranslateText>ZADNE_UDAJE</TranslateText>
                }}
            />
        </>
    );
};

export default DetailLei;
